import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizSimpleTextQuestion from "@/components/quiz/QuizSimpleTextQuestion.vue";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
import OpenQuestion from "@/components/quiz/OpenQuestion.vue";
let OpenQuestionQuiz = class OpenQuestionQuiz extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "quiz", void 0);
    _defineProperty(this, "quizResult", void 0);
    _defineProperty(this, "isResultMode", void 0);
    _defineProperty(this, "canEdit", void 0);
    _defineProperty(this, "isSpeachTemplate", void 0);
    _defineProperty(this, "realtimeUserAnswer", null);
  }
  mounted() {
    this.realtimeUserAnswer = this.quizResult;
    if (this.quiz && !this.realtimeUserAnswer) {
      this.realtimeUserAnswer = this.initRealtimeUserAnswer(this.quiz);
    }
  }
  get realtimeUserQuestions() {
    return this.realtimeUserAnswer?.questions || [];
  }
  initRealtimeUserAnswer(quiz) {
    return {
      contenuQuizId: quiz.id,
      questions: quiz.questions?.map(question => ({
        questionId: question.id,
        questionType: question.type,
        order: question.order,
        blanksText: question.blanksText,
        responsesIds: [],
        responseContent: ''
      })) || []
    };
  }
  onAnswerChange(realtimeUserAnswer) {
    return realtimeUserAnswer;
  }
};
__decorate([Prop({
  required: true
})], OpenQuestionQuiz.prototype, "quiz", void 0);
__decorate([Prop({
  default: null
})], OpenQuestionQuiz.prototype, "quizResult", void 0);
__decorate([Prop({
  default: false
})], OpenQuestionQuiz.prototype, "isResultMode", void 0);
__decorate([Prop({
  default: false
})], OpenQuestionQuiz.prototype, "canEdit", void 0);
__decorate([Prop({
  default: false
})], OpenQuestionQuiz.prototype, "isSpeachTemplate", void 0);
__decorate([Emit('answerChange')], OpenQuestionQuiz.prototype, "onAnswerChange", null);
OpenQuestionQuiz = __decorate([Component({
  components: {
    OpenQuestion,
    QuizReadonlyAlert,
    QuizSimpleTextQuestion,
    WInput,
    StandardButton
  }
})], OpenQuestionQuiz);
export default OpenQuestionQuiz;